import { FormField, Input } from "@repo/skapa";
import { t } from "@repo/translation";

import {
  type NewProjectState,
  type NewProjectStateActions,
} from "../NewProjectReducer";

interface Props {
  state: NewProjectState;
  actions: NewProjectStateActions;
}
export const TitleInput = ({ state, actions }: Props) => {
  return (
    <FormField
      valid={Boolean(state?.opportunityInfo?.title)}
      shouldValidate
      validation={{
        msg: t("label.required_field"),
        id: "error",
        type: "error",
      }}
      fieldHelper={{
        msg: t("prompt.helper_title"),
      }}
    >
      <Input
        id="new-project-title"
        type="text"
        label={t("label.title")}
        value={state.opportunityInfo?.title}
        onChange={(e) => {
          actions.setTitle(e.target.value);
        }}
      />
    </FormField>
  );
};
